import { useQuery } from '@tanstack/react-query';
import { dataSelector } from '@nextiva/global-store';
import { useSelector } from 'react-redux';
import { getPhoneNumberSoleProprietor } from 'services';
import { useSnackbar } from 'hooks';
import { PHONE_NUMBER_FOR_SOLE_PROPRIETOR } from '../constants';

const errorMessage = 'Something went wrong, please try again later.';
export function useGetPhoneNumberSoleProprietor() {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNbr = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const setSnackbar = useSnackbar();

  const data = useQuery([PHONE_NUMBER_FOR_SOLE_PROPRIETOR, corpAcctNbr], {
    queryFn: () => getPhoneNumberSoleProprietor(corpAcctNbr),
    enabled: !!corpAcctNbr,
    onError: (error) => {
      const errorResponse = error as {
        response?: { data?: { displayMessage?: string } };
      };
      setSnackbar({
        message: errorResponse?.response?.data?.displayMessage || errorMessage,
        severity: 'error',
      });
    },
  });

  return data;
}
